import React from 'react';
import { Typography, Box } from '@mui/material';
import { CopyText } from '../text';

const SplitPaymentInfo: React.FC<{ version: number }> = ({ version }) => (
	<Box sx={{ textAlign: 'left', margin: (theme) => theme.spacing(2, 0) }}>
		<Typography variant='body1' gutterBottom>
			<strong>Split Payment Plan Information:</strong>
		</Typography>
		{version === 1 ? (
			<>
				<CopyText>
					If you choose to enter into a split payment plan, once you have made your initial payment today you do not
					need to do anything; the next payment will be taken automatically from the card you pay with.
				</CopyText>
				<CopyText>
					We can also confirm that Granite Finance has reinstated your direct debit mandate with your bank.
				</CopyText>
				<CopyText>
					Payment will be taken each week until the balance is cleared. If we are unable to take subsequent instalments
					due to insufficient funds, we will re-attempt the payment two days after its due date. If this payment is also
					unsuccessful your policy will be cancelled with immediate effect due to non-payment.
				</CopyText>
				<CopyText>
					Your next full direct debit will be taken as normal, as per your original finance payment plan.
				</CopyText>
			</>
		) : (
			<>
				<CopyText>
					If you have missed a payment, or if you need a bit more time to pay, then we can offer you a ‘Split Payment
					Plan’.
				</CopyText>
				<CopyText>
					This means you can split your missed payment over weekly instalments. It will mean you will need to&nbsp;
					<strong>make the first payment today</strong>, then your next payment will be taken automatically in 7 days’
					time.
				</CopyText>
				<CopyText>
					Payment will be taken until the balance is cleared. If we are unable collect a payment from you,&nbsp;
					<strong>we will not re-attempt to take the payment again.</strong>
					&nbsp; This means you will need to pay the outstanding balance in full otherwise your insurance policy will be
					cancelled.
				</CopyText>
			</>
		)}
	</Box>
);

export default SplitPaymentInfo;
